<template>
  <div class="login">
    <div class="login-qrCode">
      <img class="logo" :src="require('@/assets/image/logo.png')">
      <p class="wechat">微信登录</p>
      <img :src="loginQrcode" class="qrcode" width="150">
      <p class="scan">使用微信扫描二维码登录“萌名片”</p>
    </div>
    <div class="introduce">萌名片·品牌营销的数字化工具</div>
    <div class="copyright">广州小萌科技有限公司 版权所有 2020-2021 <a href="http://beian.miit.gov.cn" target="_blank">粤ICP备2021130583号</a></div>
  </div>
</template>
<script>
import { useRouter } from 'vue-router'
import { onBeforeMount, onMounted, onUnmounted, ref } from 'vue'
import axios from '@/common/utils/axios'
export default {
  setup () {
    const router = useRouter()
    let token = ''
    /**
     * 查询登录二维码
     */
    const loginQrcode = ref('')
    const queryQrcode = () => {
      axios('/mp/login/qrcode', {})
        .then(res => {
          loginQrcode.value = res.loginQrcode
          token = res.token
        }).catch(_ => { })
    }
    onBeforeMount(() => {
      queryQrcode()
    })
    /**
     * 设置定时任务--查询登录二维码
     */
    let qrCodeTimer = null
    const pollingQrCode = () => {
      qrCodeTimer = setInterval(() => {
        queryQrcode()
      }, 300000)
    }

    /**
     * 设置定时任务--查询登录状态
     */
    let loginStateTimer = null
    const pollingLoginState = () => {
      loginStateTimer = setInterval(() => {
        axios('/admin/user/login', {
          token: token
        }, { loading: false }).then(res => {
          if (res.mid) {
            router.push('/institution/choose-enterprise')
          }
        }).catch(_ => { })
      }, 2000)
    }

    // 开始轮询
    onMounted(() => {
      sessionStorage.clear()
      pollingLoginState()
      pollingQrCode()
    })
    // 销毁轮询
    onUnmounted(() => {
      clearInterval(qrCodeTimer)
      clearInterval(loginStateTimer)
    })
    return { loginQrcode }
  }
}
</script>
<style lang="scss" scoped>
.login {
  height: 100%;
  background-color: $bg-gray;
  .login-qrCode {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-55%);
    width: 400px;
    height: 400px;
    background-color: #fff;
    text-align: center;
    border-radius: 3px;
    .logo {
      width: 150px;
      margin-top: 40px;
    }
    .wechat{
      margin-top: 35px;
      font-weight: 500;
    }
    .qrCode {
      border: 1px solid $border-gray;
      margin-top: 25px;
      margin-left: 50%;
      transform: translateX(-50%);
    }
    .scan {
      margin-top: 35px;
      color: $font-gray;
      font-size: $fs14;
    }
  }
  .introduce,.copyright {
    width: 100%;
    position: absolute;
    text-align: center;
  }
  .introduce {
    bottom: 60px;
    color: $font-gray;
  }
  .copyright {
    bottom: 30px;
    font-size: $fs12;
    color: $font-light-gray;
  }
}
</style>
